import { render } from "./RootPage.vue?vue&type=template&id=3388e9c0&scoped=true"
import script from "./RootPage.vue?vue&type=script&lang=js"
export * from "./RootPage.vue?vue&type=script&lang=js"

import "./RootPage.vue?vue&type=style&index=0&id=3388e9c0&lang=scss&scoped=true"

import exportComponent from "/Users/pinball73/RaceBonus/rbonus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3388e9c0"]])

export default __exports__